import React, { useState } from 'react'

// Model
import Ecwt from 'models/Ecwt'

// Use
import useTable from 'use/table'

// Constants
import { API_ECWT_LIST } from 'constants/endpoints'
import { PATH_ECWT_VIEW } from 'routes/paths'

// Components
import Link from 'ui/Link'
import Heading from 'ui/Heading'
import Datatable from 'ui/Datatable'
import Text from 'ui/Text'
import EcwtTrackerFilter, { defaultFilters } from './EcwtTrackerFilter'
import ColumnCreatedAtMobile from './Columns/ColumnCreatedAtMobile'
import ColumnFileNameMobile from './Columns/ColumnFileNameMobile'
import ColumnAction from './Columns/ColumnAction'

export const EcwtTracker = () => {
  const [filters, setFilters] = useState(defaultFilters)
  const { loading, data, total, page, onSortChange, onPageChange } = useTable({
    url: API_ECWT_LIST,
    method: 'POST',
    filters,
    model: Ecwt,
  })

  const onFiltersChange = (filters) => {
    setFilters(filters)
  }

  const rowHighlight = (row) => {
    return row.isAcknowledge ? null : 'row-highlight'
  }

  const columns = [
    {
      title: 'Date added',
      dataIndex: 'createdAt',
      sorter: true,
      sortKey: 'createDate',
      renderMobile(text, row) {
        return <ColumnCreatedAtMobile row={row} />
      },
    },
    {
      title: 'File name',
      dataIndex: 'fileName',
      sorter: true,
      render(text, row) {
        return (
          <Link
            path={PATH_ECWT_VIEW}
            params={{
              id: row.id,
            }}
            underline
            style={{ wordBreak: 'break-all' }}
          >
            {row.fileName}
          </Link>
        )
      },
      renderMobile(text, row) {
        return <ColumnFileNameMobile row={row} />
      },
    },
    {
      title: 'Acknowledged?',
      dataIndex: 'isAcknowledge',
      width: 140,
      render(text, row) {
        return (
          <>
            <Text color={row.acknowledgedColor}>• {row.acknowledgedText}</Text>
            {row.isAcknowledge && (
              <Text color="#606060" paddingLeft={10}>
                {row.acknowledgeDate}
              </Text>
            )}
          </>
        )
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: 140,
      noWrap: true,
      render(text, row) {
        return <span style={{ color: row.statusColor }}>• {row.status}</span>
      },
    },
    {
      title: 'Action',
      dataIndex: 'action',
      width: 140,
      noWrap: true,
      render(text, row) {
        return <ColumnAction row={row} />
      },
    },
  ]

  return (
    <>
      <Heading size={18}>e-CWT record</Heading>
      <Datatable
        responsive={true}
        loading={loading}
        rowHighlight={rowHighlight}
        page={page}
        columns={columns}
        data={data}
        total={total}
        perPage={10}
        onPageChange={onPageChange}
        onSortChange={onSortChange}
      >
        <EcwtTrackerFilter
          filters={filters}
          onFiltersChange={onFiltersChange}
        />
      </Datatable>
    </>
  )
}

export default EcwtTracker
